import { FC } from 'react';
import Link from 'next/link';
import styles from './AldebaranLink.module.scss';

const AldebaranLink: FC<{ url: string; title: string }> = ({ url, title }) => {
  return (
    <Link prefetch={false} href={url} className={styles.aldebaranLink}>
      {title}
    </Link>
  );
};
export default AldebaranLink;
